'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Icon = require('../icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _IDTextbox2 = require('./IDTextbox');

var _IDTextbox3 = _interopRequireDefault(_IDTextbox2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IDNumber = function (_IDTextbox) {
    (0, _inherits3.default)(IDNumber, _IDTextbox);

    function IDNumber() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, IDNumber);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IDNumber.__proto__ || (0, _getPrototypeOf2.default)(IDNumber)).call.apply(_ref, [this].concat(args))), _this), _this.dataTestID = 'number', _this.inputType = 'number', _this.onIncrease = function () {
            var _this$state = _this.state,
                value = _this$state.value,
                max = _this$state.max;

            var newValue = (value || 0) + 1;
            if (max === null || max === undefined || max === "") {
                _this.setValue(newValue);
            } else if ((value || 0) < max) {
                _this.setValue(_lodash2.default.min([newValue, max]));
            }
        }, _this.onDecrease = function () {
            var _this$state2 = _this.state,
                value = _this$state2.value,
                min = _this$state2.min;

            var newValue = (value || 0) - 1;
            if (min === null || min === undefined || min === "") {
                _this.setValue(newValue);
            } else if ((value || 0) > min) {
                _this.setValue(_lodash2.default.max([newValue, min]));
            }
        }, _this.onKeyDown = function (e) {
            if (e.keyCode === 38) {
                _this.onIncrease();
            }
            if (e.keyCode === 40) {
                _this.onDecrease();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(IDNumber, [{
        key: 'renderIncreaseAndDecrease',
        value: function renderIncreaseAndDecrease() {
            var visibleInCreaseAndDecrease = this.props.visibleInCreaseAndDecrease;

            if (!visibleInCreaseAndDecrease) {
                return "";
            }
            return _react2.default.createElement(
                'div',
                { className: 'increase-and-decrease' },
                _react2.default.createElement(
                    'span',
                    {
                        className: 'increase',
                        onClick: this.onIncrease
                    },
                    _react2.default.createElement(_Icon2.default, {
                        type: 'up',
                        className: 'icon-increase',
                        style: { fontSize: 10, color: '#d9d9d9' }
                    })
                ),
                _react2.default.createElement(
                    'span',
                    {
                        className: 'decrease',
                        onClick: this.onDecrease
                    },
                    _react2.default.createElement(_Icon2.default, {
                        type: 'down',
                        className: 'icon-decrease',
                        style: { fontSize: 10, color: '#d9d9d9' }
                    })
                )
            );
        }
    }]);
    return IDNumber;
}(_IDTextbox3.default);

exports.default = IDNumber;


IDNumber.defaultProps = (0, _extends3.default)({}, _IDTextbox3.default.defaultProps, {
    type: "cleave",
    iconType: 'number',
    visibleInCreaseAndDecrease: false,
    options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand'
    }
});